import { supabase } from "@/integrations/supabase/client";

/**
 * Call after a user successfully downloads course materials (e.g. slides).
 * Sets free_course_download_used on their profile only if they are on the free tier
 * (no active subscription). Admins and subscribed users are not marked.
 */
export async function markFreeCourseDownloadUsed(): Promise<void> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  const { data: profile } = await supabase
    .from("profiles")
    .select("subscription_status, free_course_download_used")
    .eq("id", user.id)
    .single();

  const activeSubscription =
    profile?.subscription_status === "active" || profile?.subscription_status === "trialing";
  if (activeSubscription || profile?.free_course_download_used) return;

  const { data: adminRow } = await supabase
    .from("user_roles")
    .select("role")
    .eq("user_id", user.id)
    .eq("role", "admin")
    .limit(1)
    .maybeSingle();
  if (adminRow?.role === "admin") return;

  await supabase
    .from("profiles")
    .update({ free_course_download_used: true })
    .eq("id", user.id);
}
